import React, { PropsWithChildren } from 'react';

import BackButton from 'components/curo-components/common/BackButton';

import styles from './BackButton.module.scss';

interface IWithBackButtonProps {
  onBackButtonClick: () => void;
}

const WithBackButton = ({
  onBackButtonClick,
  children,
}: PropsWithChildren<IWithBackButtonProps>) => {
  return (
    <div className={styles.buttonsWrapper}>
      <BackButton onClick={onBackButtonClick} />
      {children}
    </div>
  );
};

export default WithBackButton;
